import { SceneEvent } from './vr-events/SceneEvent';
import { OutcomeAction } from './outcomes/OutcomeAction';

export class Scene {
    sceneId: number;
    name: string;
    description: string;
    projectId: number;
    sceneBackgroundFileType: string;
    sceneBackgroundSrc: string;
    sceneBackgroundColour: string;
    active: boolean;
    sceneIndex: number;
    timeStamp: Date;
    wireframe: boolean;
    events: SceneEvent[] = [];
    autoplay: boolean;
    loop: boolean;
    outcomeActions: OutcomeAction[];
    opened:boolean;
    sceneBackgroundFileSize: number;
    uploadStatus: string;
    xRot: string;
    yRot: string;
}